import {
    GOStagingMap,
    languages,
    position_x,
    position_y,
    themes,
} from "@goaigua/go-gisapi";
import { configOptions } from "@goaigua/go-gisapi/dist/goapi/utils/types";
import Map from "ol/Map";
import { IntlShape } from "react-intl";
import { Themes } from "redux/reducers/global/hooks/use-theme-selector";
import { SetStateType } from "types/generic";
import {
    getEnvVariable,
    REACT_APP_MAP_DEFAULT_COORD,
    REACT_APP_MAP_DEFAULT_ZOOM,
} from "utils/environment";

export const configMap = (
    layers: any[],
    intl: IntlShape,
    appTheme: string
): any => {
    layers.forEach((layer) => {
        layer.id = layer.id.toString();
        layer.defaultVisibility = false;
    });

    const language: "EN" | "ES" = intl.locale.split("-")[0].toUpperCase() as
        | "EN"
        | "ES";

    const defineTOCTheme = (): "LIGHT" | "DARK" => {
        const themes: Record<string, "LIGHT" | "DARK"> = {
            light: "LIGHT",
            dark: "DARK",
        };

        return themes[appTheme] || "DARK";
    };

    const defaultCoordindatesString = getEnvVariable(
        REACT_APP_MAP_DEFAULT_COORD
    ).split(",");

    return {
        GOMapOptions: [
            {
                id: "marker",
                div: "mapa",
                optionView: {
                    id: "vista1",
                    center: [
                        +defaultCoordindatesString[0],
                        +defaultCoordindatesString[1],
                    ],
                    zoom: +getEnvVariable(REACT_APP_MAP_DEFAULT_ZOOM),
                    projection: "3857",
                },
                optionToc: {
                    id: "toc-container",
                    lang: languages[language],
                    theme: themes[defineTOCTheme()],
                    active: true,
                    position_x: position_x.RIGHT,
                    position_y: position_y.TOP,
                    max_height: 380,
                    margin_lateral: 40,
                    legend: true,
                    no_switcher: [
                        {
                            folder: "Capas Base/",
                            unique_active: true,
                        },
                    ],
                },
                layer: [
                    ...layers,
                    {
                        id: "DarkTheme",
                        alias: "DarkTheme",
                        layerType: "GO_MAPBOX",
                        isBaseLayer: true,
                        urlFolder: "Capas Base/",
                        style: "ckugiqlos8tem17mpk9ne2oxd",
                        token: "pk.eyJ1IjoiaWRyaWNhIiwiYSI6ImNrdWZpNHAwOTFlOHcycm10ZWlvcTJodTkifQ.kDBecIZHGx-7nf807n2xIQ",
                        epsg: 4326,
                    },
                    {
                        id: "LightTheme",
                        alias: "LightTheme",
                        layerType: "GO_MAPBOX",
                        isBaseLayer: true,
                        urlFolder: "Capas Base/",
                        style: "ckugis5on3dz917ql0ml326rk",
                        token: "pk.eyJ1IjoiaWRyaWNhIiwiYSI6ImNrdWZpNHAwOTFlOHcycm10ZWlvcTJodTkifQ.kDBecIZHGx-7nf807n2xIQ",
                        epsg: 4326,
                    },
                    // {
                    //     // id: "iot_layer",
                    //     reloadFrequency: 15000,
                    //     labelNameIOT: "label_iotsignal",
                    //     gisHierarchyItemId: 83,
                    //     filter: "",
                    //     useBboxFilter: false,
                    //     env: "https://gateway-proxy-gis-devtools.go-aigua.com",
                    //     layerId: "iot_layer",
                    //     alias: "IOT Layer Test SOC",
                    //     layerType: "GO_IOT_LAYER",
                    //     isBaseLayer: false,
                    //     opacity: 1,
                    //     empty: false,
                    //     url: "https://gateway-proxy.dev.idrica.pro/geoserver/testDMD",
                    //     urlFolder: "TEST",
                    //     query: true,
                    //     layerName: "testDMD:dmd_test_label",
                    //     defaultVisibility: true,
                    //     zIndex: 99,
                    //     epsg: "",
                    //     srs: "EPSG:3857",
                    //     token: "",
                    //     esri: false,
                    //     password: "",
                    //     user: "",
                    //     minResolution: "NaN",
                    //     maxResolution: "NaN",
                    // },
                ],
            },
        ],
    };
};

export const setBaseLayerBasedOnTheme = (theme: Themes, map: GOStagingMap) => {
    const darkLayer = map.getLayer("DarkTheme");
    const lightLayer = map.getLayer("LightTheme");

    if (theme === "dark") {
        darkLayer.setVisibility(true);
        lightLayer.setVisibility(false);
    } else {
        darkLayer.setVisibility(false);
        lightLayer.setVisibility(true);
    }
};

export const setPointerOnMapMove = (mainMap: Map, evt: any) => {
    const features = mainMap.getFeaturesAtPixel(evt.pixel);
    if (features.length > 0) {
        const elementToChange = document.getElementsByTagName("body")[0];
        elementToChange.style.cursor = "pointer";
    } else {
        const elementToChange = document.getElementsByTagName("body")[0];
        elementToChange.style.cursor = "auto";
    }
};

export const removeExtraMapsFromDOM = (tocElement?: HTMLDivElement | null) => {
    const mapContainer = document.querySelector(".ol-viewport");
    mapContainer?.parentNode?.removeChild(mapContainer);

    if (tocElement) {
        tocElement.innerHTML = "";
    }
};

export const updateMapTheme = (mainMap: GOStagingMap, theme: string) => {
    mainMap?.setTheme(theme === "dark" ? "DARK" : ("LIGHT" as any));
    setBaseLayerBasedOnTheme(theme as Themes, mainMap);
};

export const toggleTocActive = (setTocIsOpen: SetStateType<boolean>) => {
    document.getElementById("ownTocContainer")?.classList.toggle("active");
    document.getElementById("btn-toc")?.classList.toggle("btn-active");
    setTocIsOpen((prev) => !prev);
};
